import { render, staticRenderFns } from "./offer-dialog.vue?vue&type=template&id=55d4e2e8&"
import script from "./offer-dialog.vue?vue&type=script&lang=js&"
export * from "./offer-dialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "offer-dialog.vue"
export default component.exports